(()=>{
  'use strict';
  const body=document.body;
  const search=document.querySelector('[data-eg-search]');
  const drawer=document.querySelector('[data-eg-drawer]');
  const backdrop=document.querySelector('[data-eg-drawer-backdrop]');
  const filter=document.querySelector('[data-eg-filter]');
  const header=document.querySelector('[data-eg-header]');

  const lock=()=>{
    const scrollbarWidth=Math.max(0,window.innerWidth-document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--eg-scrollbar-comp',`${scrollbarWidth}px`);
    body.classList.add('eg-lock');
  };
  const unlock=()=>{
    if(!search?.classList.contains('is-open')&&!drawer?.classList.contains('is-open')&&!filter?.classList.contains('is-open')){
      body.classList.remove('eg-lock');
      document.documentElement.style.removeProperty('--eg-scrollbar-comp');
    }
  };

  const openSearch=()=>{
    if(!search)return;
    closeDrawer();
    closeAccountMenus();
    search.classList.add('is-open');
    search.setAttribute('aria-hidden','false');
    lock();
    setTimeout(()=>search.querySelector('input[type="search"]')?.focus(),80);
  };
  const closeSearch=()=>{
    search?.classList.remove('is-open');
    search?.setAttribute('aria-hidden','true');
    unlock();
  };
  const openDrawer=()=>{
    if(!drawer)return;
    closeSearch();
    closeAccountMenus();
    drawer.classList.add('is-open');
    backdrop?.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.querySelector('[data-eg-menu-open]')?.setAttribute('aria-expanded','true');
    lock();
  };
  const closeDrawer=()=>{
    drawer?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden','true');
    document.querySelector('[data-eg-menu-open]')?.setAttribute('aria-expanded','false');
    unlock();
  };
  const openFilter=()=>{
    if(!filter)return;
    filter.classList.add('is-open');
    lock();
  };
  const closeFilter=()=>{
    filter?.classList.remove('is-open');
    unlock();
  };

  const closeAccountMenus=()=>{};

  document.addEventListener('click',e=>{
    if(e.target.closest('[data-eg-search-open]')){e.preventDefault();openSearch();}
    if(e.target.closest('[data-eg-search-close]')||e.target===search)closeSearch();
    if(e.target.closest('[data-eg-menu-open]')){e.preventDefault();openDrawer();}
    if(e.target.closest('[data-eg-menu-close]')||e.target===backdrop)closeDrawer();
    if(e.target.closest('[data-eg-filter-open]')){e.preventDefault();openFilter();}
    if(e.target.closest('[data-eg-filter-close]'))closeFilter();

  });
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'){
      closeSearch();
      closeDrawer();
      closeFilter();
      closeAccountMenus();
    }
  });

  let headerTick=false;
  const onScroll=()=>{
    if(headerTick)return;
    headerTick=true;
    window.requestAnimationFrame(()=>{
      header?.classList.toggle('is-scrolled',window.scrollY>16);
      headerTick=false;
    });
  };
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();

  document.querySelectorAll('[data-eg-qty]').forEach(q=>{
    const input=q.querySelector('input');
    const step=()=>Number(input?.step||1)||1;
    const min=()=>Number(input?.min||0)||0;
    const max=()=>input?.max?Number(input.max):Infinity;
    q.querySelector('[data-minus]')?.addEventListener('click',()=>{
      if(!input)return;
      const next=Math.max(min(),Number(input.value||min())-step());
      input.value=next;input.dispatchEvent(new Event('change',{bubbles:true}));
    });
    q.querySelector('[data-plus]')?.addEventListener('click',()=>{
      if(!input)return;
      const next=Math.min(max(),Number(input.value||min())+step());
      input.value=next;input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  const gallery=document.querySelector('[data-eg-gallery]');
  const galleryWrap=document.querySelector('[data-eg-gallery-wrap]');
  const galleryThumbs=[...document.querySelectorAll('[data-eg-gallery-thumb]')];
  const isMobileGallery=()=>window.matchMedia('(max-width: 640px)').matches;

  const setActiveGalleryThumb=(mediaId)=>{
    if(!mediaId)return;
    galleryThumbs.forEach(thumb=>{
      const active=thumb.dataset.targetMedia===String(mediaId);
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-current',active?'true':'false');
      if(active&&isMobileGallery()){
        thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
      }
    });
  };

  const activateProductMedia=(mediaId,{smooth=true}={})=>{
    if(!gallery||!mediaId)return;
    const target=gallery.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`);
    if(!target)return;

    gallery.querySelectorAll('[data-media-id].is-variant-media').forEach(el=>el.classList.remove('is-variant-media'));
    target.classList.add('is-variant-media');
    gallery.classList.add('has-variant-media');
    setActiveGalleryThumb(mediaId);

    if(isMobileGallery()){
      const left=Math.max(0,target.offsetLeft-gallery.offsetLeft);
      gallery.scrollTo({left,behavior:smooth?'smooth':'auto'});
    }
  };

  galleryThumbs.forEach(thumb=>{
    thumb.addEventListener('click',()=>{
      const mediaId=thumb.dataset.targetMedia;
      const target=gallery?.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`);
      if(!gallery||!target)return;
      setActiveGalleryThumb(mediaId);
      gallery.scrollTo({left:Math.max(0,target.offsetLeft-gallery.offsetLeft),behavior:'smooth'});
    });
  });

  if(gallery){
    let galleryScrollTick=false;
    gallery.addEventListener('scroll',()=>{
      if(!isMobileGallery()||galleryScrollTick)return;
      galleryScrollTick=true;
      requestAnimationFrame(()=>{
        const items=[...gallery.querySelectorAll('[data-media-id]')];
        if(items.length){
          const current=items.reduce((best,item)=>{
            const distance=Math.abs((item.offsetLeft-gallery.offsetLeft)-gallery.scrollLeft);
            return !best||distance<best.distance?{item,distance}:best;
          },null);
          if(current?.item?.dataset.mediaId)setActiveGalleryThumb(current.item.dataset.mediaId);
        }
        galleryScrollTick=false;
      });
    },{passive:true});
  }

  const variantSelect=document.querySelector('[data-variant-select]');
  if(variantSelect){
    const syncVariant=(smooth=true)=>{
      const option=variantSelect.options[variantSelect.selectedIndex];
      if(!option)return;
      const id=option.value;
      const sku=option.dataset.sku||'';
      const mediaId=option.dataset.mediaId;
      const skuEl=document.querySelector('[data-product-sku]');
      if(skuEl)skuEl.textContent=sku;
      if(mediaId)activateProductMedia(mediaId,{smooth});
      const url=new URL(window.location.href);
      url.searchParams.set('variant',id);
      window.history.replaceState({},'',url);
    };
    variantSelect.addEventListener('change',()=>syncVariant(true));
    syncVariant(false);
  }else if(galleryWrap){
    const first=gallery?.querySelector('[data-media-id]');
    if(first?.dataset.mediaId)setActiveGalleryThumb(first.dataset.mediaId);
  }

  document.querySelectorAll('[data-copy-sku]').forEach(button=>{
    button.addEventListener('click',async()=>{
      const sku=button.closest('.eg-product__sku')?.querySelector('[data-product-sku]')?.textContent?.trim();
      if(!sku)return;
      const original=button.textContent;
      try{
        await navigator.clipboard.writeText(sku);
        button.textContent='Copiato';
      }catch(_){
        const area=document.createElement('textarea');
        area.value=sku;
        area.setAttribute('readonly','');
        area.style.position='fixed';
        area.style.opacity='0';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        area.remove();
        button.textContent='Copiato';
      }
      window.setTimeout(()=>{button.textContent=original;},1200);
    });
  });


  // Technical-document modal (PDF/image) — stays inside the product page.
  const docModal=document.querySelector('[data-eg-doc-modal]');
  const docFrame=docModal?.querySelector('[data-eg-doc-frame]');
  const docTitle=docModal?.querySelector('[data-eg-doc-title]');
  let docLastTrigger=null;
  const openDocModal=(trigger)=>{
    if(!docModal||!docFrame||!trigger)return;
    const url=trigger.dataset.docUrl;
    if(!url)return;
    docLastTrigger=trigger;
    if(docTitle)docTitle.textContent=trigger.dataset.docTitle||'Documento';
    docFrame.src=url;
    docModal.classList.add('is-open');
    docModal.setAttribute('aria-hidden','false');
    document.body.classList.add('eg-doc-open');
    window.setTimeout(()=>docModal.querySelector('[data-eg-doc-close]')?.focus(),30);
  };
  const closeDocModal=()=>{
    if(!docModal)return;
    docModal.classList.remove('is-open');
    docModal.setAttribute('aria-hidden','true');
    document.body.classList.remove('eg-doc-open');
    if(docFrame)docFrame.src='about:blank';
    docLastTrigger?.focus();
    docLastTrigger=null;
  };
  document.addEventListener('click',e=>{
    const docTrigger=e.target.closest('[data-eg-doc-open]');
    if(docTrigger){e.preventDefault();openDocModal(docTrigger);return;}
    if(e.target.closest('[data-eg-doc-close]')){e.preventDefault();closeDocModal();}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&docModal?.classList.contains('is-open'))closeDocModal();});

  document.querySelectorAll('[data-product-recommendations]').forEach(section=>{
    if(section.innerHTML.trim())return;
    const url=section.dataset.url;
    if(!url)return;
    fetch(url).then(r=>r.text()).then(html=>{
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('[data-product-recommendations]');
      if(fresh&&fresh.innerHTML.trim())section.innerHTML=fresh.innerHTML;
    }).catch(()=>{});
  });

  class PredictiveSearch extends HTMLElement{
    constructor(){
      super();
      this.input=this.querySelector('input[type="search"]');
      this.results=this.querySelector('#eg-predictive-search');
      this.controller=null;
      this.timer=null;
      this.input?.addEventListener('input',()=>{
        clearTimeout(this.timer);
        this.timer=setTimeout(()=>this.onChange(),220);
      });
      this.input?.addEventListener('keydown',e=>{if(e.key==='Escape')this.clear();});
    }
    onChange(){
      const term=this.input.value.trim();
      if(term.length<2){this.clear();return;}
      this.fetchResults(term);
    }
    fetchResults(term){
      if(this.controller)this.controller.abort();
      this.controller=new AbortController();
      const base=this.dataset.predictiveUrl||'/search/suggest';
      const url=`${base}?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=show&section_id=eg-predictive-search`;
      fetch(url,{signal:this.controller.signal})
        .then(r=>{if(!r.ok)throw new Error(r.status);return r.text();})
        .then(text=>{
          const doc=new DOMParser().parseFromString(text,'text/html');
          const section=doc.querySelector('#shopify-section-eg-predictive-search');
          if(!section)return;
          this.results.innerHTML=section.innerHTML;
          this.results.classList.add('is-open');
          this.input.setAttribute('aria-expanded','true');
        }).catch(err=>{if(err.name!=='AbortError')this.clear();});
    }
    clear(){
      if(this.results){this.results.innerHTML='';this.results.classList.remove('is-open');}
      this.input?.setAttribute('aria-expanded','false');
    }
  }
  if(!customElements.get('predictive-search'))customElements.define('predictive-search',PredictiveSearch);
})();


/* ELEGANZA v1.2.2 — contact submit feedback */
document.addEventListener('DOMContentLoaded', function(){
  var form=document.getElementById('EgContactForm');
  if(!form) return;
  form.addEventListener('submit', function(){
    var btn=form.querySelector('.eg-contact-submit');
    if(btn && form.checkValidity()){
      btn.disabled=true;
      btn.setAttribute('aria-busy','true');
      var label=btn.querySelector('span');
      if(label) label.textContent='Invio in corso…';
    }
  });
  var success=form.querySelector('.eg-form-success');
  if(success){
    setTimeout(function(){ success.scrollIntoView({behavior:'smooth',block:'center'}); },80);
  }
});
